import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import gsap from "gsap";
import {IFsSymbolData} from "../symbols/freespin/FreespinSymbol";
import {ArrayHelper} from "@nolimit/slot-game/bin/utils/ArrayHelper";
import {ChestSymbol} from "../symbols/freespin/ChestSymbol";

export class ChestRow extends PIXI.Container{
    private _chests:ChestSymbol[];
    private _level: number = 0;
    private _isRevealed: boolean = false;

    constructor() {
        super();
        this.name = "ChestRow";
        this.position = new PIXI.Point(60,610);
    }

    public init(symbolData: IFsSymbolData[]): void {
        this._chests = ArrayHelper.initArrayWithValues(6, (i:number)=>{
            const chest:ChestSymbol = new ChestSymbol(symbolData[i]);
            chest.position.set(100*i, 0);
            return chest;
        });

    }

    public getDynamite(reelId:number): gsap.core.Timeline {
        return this._chests[reelId].getDynamite();
    }

    public remove(): void {
        this._chests.forEach((chest:ChestSymbol)=>{
            chest.remove();
        });
    }

    public show(): void {
        this._chests.forEach((chest:ChestSymbol)=>{
            this.addChild(chest);
        });
        this._chests.forEach((chest:ChestSymbol)=>{
            if(chest.isRevealed){
                this.addChild(chest);
            }
        });
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
        this.reset();
    }

    public reset(): void {
        this._chests.forEach((chest:ChestSymbol)=>{
            chest.reset();
        });
    }

    public getChest(reelId:number): ChestSymbol {
        return this._chests[reelId];
    }
}